import { Page } from "../components/ui.jsx";
import { WORSHIP } from "../data/worship.js";

export default function Worship({ back }) {
  return (
    <Page
      back={back}
      eyebrow="CLLXTV Music"
      title="Worship, from our room to yours."
      intro="What we're singing on Sundays — press play right here."
    >
      <div className="block">
        <h3>Song of the Day</h3>
        <p>Coming soon — the worship team is queuing up this week's song.</p>
      </div>

      {WORSHIP.playlists.map((p) => (
        <div key={p.title} className="block">
          <h3>{p.title}</h3>
          <p>{p.desc}</p>
          {/* Playlists still set to REPLACE_ME render as copy only, no empty player. */}
          {p.listId !== "REPLACE_ME" && (
            <div className="player">
              <iframe
                src={`https://www.youtube.com/embed/videoseries?list=${p.listId}&rel=0`}
                title={p.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          )}
        </div>
      ))}
    </Page>
  );
}
